import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../Components/Sidebar";
import Header from "../Components/Header";
import Select from "react-select";
import ReactDatatable from "@ashvin27/react-datatable";
import EditUsersModal from "../Modals/EditUsersModal";
import DeleteUsersModal from "../Modals/DeleteUsersModal";
import AddUsersModal from "../Modals/AddUserModal";
import { getAllCMS, getAllFAQ, getUserList } from "../actions/admin";
import Exportexcel from "../Components/Excelexport";
import Papa from "papaparse";
import { addNewUserCSV } from "../actions/admin";
import toast from "react-hot-toast";
import EditFaqModal from '../Modals/EditFaqModal'
import AddFaqModal from '../Modals/AddFaqModal'
const FAQ = () => {
  const [faqLits, setfaqLits] = useState([]);

  const [showEditFaq, setShowEditFaq] = useState(false);

  const [pageNumer, setPageNumer] = useState(1);
  const [limit, setLimit] = useState(10);
  const [count, setCount] = useState(0);
  const [editRecord, setEditRecord] = useState({});
  const [showAddFaq, setshowAddFaq] = useState(false);


  const handleShowAddFaq = () => {
    setshowAddFaq(true)
  }
  const handleCloseAddFaq = () => {
    setshowAddFaq(false)
  }
  const handleShowEditFaq = (record) => {
    setShowEditFaq(true);
    setEditRecord(record);
  };

  const handleCloseEditFaq = () => {
    setShowEditFaq(false);
    setEditRecord({});
  };

  const getFAQData = async () => {
    let reqData = {
      page: pageNumer,
      limit: limit,
    };
    let { status, message, data, count } = await getAllFAQ(reqData);
    if (status == "success") {
      setfaqLits(data);
      setCount(count);
    }
  };

  const handlePagination = async (index) => {
    let reqData = {
      page: index.page_number,
      limit: index.page_size,
    };
    setPageNumer(index.page_number);
    setLimit(index.page_size);
    let { status, message, data, count } = await getFAQData(reqData);
    setfaqLits(data);
    setCount(count);
  };


  useEffect(() => {
    getFAQData();
  }, []);


  const columns = [
    {
      key: "question",
      text: "Question",
      className: "exchange_table_values text-center",
      align: "center",
      sortable: false,
    },
    {
      key: "answer",
      text: "Answer",
      className: "exchange_table_values text-center",
      align: "center",
      sortable: false,
    },
    {
      key: "action",
      text: "Action",
      className: "activity",
      align: "center",
      sortable: false,
      cell: (record) => {
        return (
          <div className="d-flex justify-content-center align-items-center gap-2">
            <button
              className="cmn_plain_btn"
              onClick={() => {
                handleShowEditFaq(record);
              }}
            >
              <img
                src={require("../assets/images/editer.svg").default}
                className="img-fluid table_activity_img"
              />{" "}
            </button>
          </div>
        );
      },
    },
  ];

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50],
    filename: "Emailtemplates",
    no_data_text: "No Email Templates found!",
    language: {
      length_menu: "Show _MENU_ result per page",
      filter: "Filter in records...",
      info: "Showing _START_ to _END_ of _TOTAL_ records",
      pagination: {
        first: "First",
        previous: "Previous",
        next: "Next",
        last: "Last",
      },
    },
    show_length_menu: false,
    show_filter: false,
    show_pagination: true,
    show_info: false,
  };

  const extraButtons = [
    {
      className: "btn btn-primary buttons-pdf",
      title: "Export TEst",
      children: [
        <span>
          <i
            className="glyphicon glyphicon-print fa fa-print"
            aria-hidden="true"
          ></i>
        </span>,
      ],
      onClick: (event) => { },
    },
    {
      className: "btn btn-primary buttons-pdf",
      title: "Export TEst",
      children: [
        <span>
          <i
            className="glyphicon glyphicon-print fa fa-print"
            aria-hidden="true"
          ></i>
        </span>,
      ],
      onClick: (event) => { },
      onDoubleClick: (event) => { },
    },
  ];
  return (
    <>
      <Container fluid className="common_bg position-relative">
        <div className="liner"></div>
        <Row>
          <Col xl={2} lg={0} className="p-0 d-none d-xl-block">
            <Sidebar />
          </Col>
          <Col xl={10} lg={12}>
            <Header title={"FAQ"} />

            <div className="text-end my-4">
              <button
                className="orange_small_primary"
                onClick={() => {
                  handleShowAddFaq(true);
                }}
              >
                Add
              </button>
            </div>

            {/* <div className="text-end mb-4">
              <button
                className="orange_small_primary"
                onClick={() => {
                  handleShowAddUsers(true);
                }}>
                Add
              </button>
            </div> */}

            <div className="common_page_scroller pb-5 pe-2">
              <div className="exchange_table_holder dashboard_box rounded-3">
                <ReactDatatable
                  config={config}
                  records={faqLits}
                  columns={columns}
                  extraButtons={extraButtons}
                  dynamic={true}
                  total_record={count}
                  onChange={(e) => {
                    handlePagination(e);
                  }}
                //   dynamic={true}
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      {/* modals */}
      <AddFaqModal
        show={showAddFaq}
        getFAQData={getFAQData}
        handleClose={handleCloseAddFaq} />

      <EditFaqModal
        show={showEditFaq}
        record={editRecord}
        getFAQData={getFAQData}
        handleClose={handleCloseEditFaq} />

      {/* end of modals */}
    </>
  );
};

export default FAQ;
